import hotjar from '@hotjar/browser';
import { DEMO_CONNECTION_INDEX, getCurrentConnectionInfo } from 'portal-sdk';
import * as React from 'react';

import { isCypress } from 'bones/utils/environment';
import { isOnPremise } from 'bones/utils/portal/environment';
import { getPortalUserTrackingData } from 'bones/utils/portal/getPortalUserTrackingData';
import { useAnalyticsConsent } from 'bones/utils/portal/useAnalyticsConsent';
import { PortalUser, usePortalUser } from 'bones/utils/portal/usePortalUser';

export const setupHotjar = (user: PortalUser) => {
  const siteId = Number.parseInt(process.env.HOTJAR_SITE_ID || '');
  const version = Number.parseInt(process.env.HOTJAR_VERSION || '');
  if (!siteId || !version || isCypress() || isOnPremise()) {
    return;
  }
  hotjar.init(siteId, version);

  if (!user.id || !user.email) {
    return;
  }

  // TODO: get undefined added to UserInfo type in https://github.com/hotjar/hotjar-js
  hotjar.identify(user.email, getPortalUserTrackingData(user) as any);
};

export const usePortalHotjar = () => {
  const consent = useAnalyticsConsent();
  const connectionInfo = getCurrentConnectionInfo(window);
  const enabled =
    consent !== null &&
    consent.statistics &&
    connectionInfo?.connectionIndex === DEMO_CONNECTION_INDEX;

  const { data: user, isLoading } = usePortalUser({
    enabled,
    refetchOnWindowFocus: false,
  });

  React.useEffect(() => {
    if (
      !enabled ||
      isLoading ||
      !user ||
      !user.is_authenticated ||
      user.is_ephemeral
    ) {
      return;
    }
    setupHotjar(user);
  }, [enabled, isLoading, user]);
};
